export default "__VITE_ASSET__Brs2T7GP__"